import * as R from 'ramda'
import { MOBILE_HEADER_HEIGHT as NAVBAR_HEIGHT } from '@components/navbar'
import { getDeviceInfo } from 'helpers/useragent'
import {
  CONTENT_BUTTONS_SIZE_MEDIUM,
  CONTENT_BUTTONS_SIZE_SMALL,
  MOBILE_TOP_SPACING,
  MODAL_DROPDOWN_HEIGHT,
  MODAL_HEADER_HEIGHT
} from 'constants/modalMobile'
import {
  GetAvailableVerticalScreenSpaceInMobileModal,
  GetTopSpacingMobileModal
} from './mobileModal.types'

export const getAvailableVerticalScreenSpaceInMobileModal: GetAvailableVerticalScreenSpaceInMobileModal = ({
  hasDropdown = false,
  isWebview,
  screenSize
}) => R.pipe(
  R.add(MODAL_HEADER_HEIGHT),
  R.ifElse(
    R.always(screenSize.small),
    R.add(CONTENT_BUTTONS_SIZE_SMALL),
    R.add(CONTENT_BUTTONS_SIZE_MEDIUM)
  ),
  R.when(
    R.always(hasDropdown),
    R.add(MODAL_DROPDOWN_HEIGHT)
  ),
  R.when(
    R.always(!isWebview),
    R.add(NAVBAR_HEIGHT)
  ),
  R.subtract(window.innerHeight)
)(0)

export const getTopSpacingMobileModal: GetTopSpacingMobileModal = () => {
  const { webview: isWebview } = getDeviceInfo()
  const navBarHeight: number = isWebview ? 0 : NAVBAR_HEIGHT

  return navBarHeight + MOBILE_TOP_SPACING
}
